import { bus_nhaxe } from "../../../models/response/bus/bus_nhaxe";

export enum eBusNhaXeActionTypeIds {
	LOAD_START = "BUS_NHAXE_LOAD_START",
	LOAD_SUCCESS = "BUS_NHAXE_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_NHAXE_LOAD_ERROR",

	SHOW_DETAIL = "BUS_NHAXE_SHOW_DETAIL",
	CLOSE_DETAIL = "BUS_NHAXE_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "BUS_NHAXE_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "BUS_NHAXE_SHOW_CONFIRM",
	CLOSE_CONFIRM = "BUS_NHAXE_CLOSE_CONFIRM",

	DELETE_START = "BUS_NHAXE_DELETE_START",
	DELETE_SUCCESS = "BUS_NHAXE_DELETE_SUCCESS",
	DELETE_ERROR = "BUS_NHAXE_DELETE_ERROR",

	SAVE_START = "BUS_NHAXE_SAVE_START",
	SAVE_SUCCESS = "BUS_NHAXE_SAVE_SUCCESS",
	SAVE_ERROR = "BUS_NHAXE_SAVE_ERROR"
}

export interface IBusNhaXeLoadStart {
	type: eBusNhaXeActionTypeIds.LOAD_START
}
export interface IBusNhaXeLoadSuccess {
	type: eBusNhaXeActionTypeIds.LOAD_SUCCESS,
	payload: bus_nhaxe[]
}
export interface IBusNhaXeLoadErr {
	type: eBusNhaXeActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusNhaXeShowDetail {
	type: eBusNhaXeActionTypeIds.SHOW_DETAIL,
	payload?: bus_nhaxe
}
export interface IBusNhaXeCloseDetail {
	type: eBusNhaXeActionTypeIds.CLOSE_DETAIL
}
export interface IBusNhaXeChangeSelectedIds {
	type: eBusNhaXeActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IBusNhaXeShowConfirm {
	type: eBusNhaXeActionTypeIds.SHOW_CONFIRM,
	payload?: bus_nhaxe
}
export interface IBusNhaXeCloseConfirm {
	type: eBusNhaXeActionTypeIds.CLOSE_CONFIRM
}
export interface IBusNhaXeDeleteStart {
	type: eBusNhaXeActionTypeIds.DELETE_START,
	payload: number
}
export interface IBusNhaXeDeleteSuccess {
	type: eBusNhaXeActionTypeIds.DELETE_SUCCESS
}
export interface IBusNhaXeDeleteErr {
	type: eBusNhaXeActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IBusNhaXeSaveStart {
	type: eBusNhaXeActionTypeIds.SAVE_START,
	payload: bus_nhaxe
}
export interface IBusNhaXeSaveSuccess {
	type: eBusNhaXeActionTypeIds.SAVE_SUCCESS
}
export interface IBusNhaXeSaveErr {
	type: eBusNhaXeActionTypeIds.SAVE_ERROR,
	payload: string
}

export type IBusNhaXeActionTypes = IBusNhaXeLoadStart | IBusNhaXeLoadSuccess | IBusNhaXeLoadErr |
	IBusNhaXeShowDetail | IBusNhaXeCloseDetail |
	IBusNhaXeChangeSelectedIds |
	IBusNhaXeShowConfirm | IBusNhaXeCloseConfirm |
	IBusNhaXeDeleteStart | IBusNhaXeDeleteSuccess | IBusNhaXeDeleteErr |
	IBusNhaXeSaveStart | IBusNhaXeSaveSuccess | IBusNhaXeSaveErr
